import { createContext, useCallback, useContext, useState } from 'react';

export enum OverlayIds {
  DELETE_CARD = 'DELETE_CARD',
  DELETE_STORED_PAYMENT = 'DELETE_STORED_PAYMENT',
  DELETE_ALL_CARDS = 'DELETE_ALL_CARDS',
  BANCONTACT_MOBILE_AUTH = 'BANCONTACT_MOBILE_AUTH',
  ADYEN_CREDIT_CARD_AUTH = 'ADYEN_CREDIT_CARD_AUTH',
  BLIK_CODE = 'BLIK_CODE',
}

interface Props {
  hideOverlay: (id: OverlayIds) => void;
  showOverlay: (id: OverlayIds) => void;
  checkIsActive: (id: OverlayIds) => boolean;
}

export const OverlaysContext = createContext<Props>({
  hideOverlay: () => null,
  showOverlay: () => null,
  checkIsActive: () => false,
});

type Overlays = {
  [k in OverlayIds]?: { isActive: boolean };
};

const OverlaysProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [overlays, setOverlays] = useState<Overlays>({});

  const hideOverlay = useCallback((id: OverlayIds) => {
    setOverlays(previousOverlays => ({ ...previousOverlays, [id]: { isActive: false } }));
  }, []);

  const showOverlay = useCallback((id: OverlayIds) => {
    setOverlays(previousOverlays => ({ ...previousOverlays, [id]: { isActive: true } }));
  }, []);

  const checkIsActive = useCallback((id: OverlayIds) => !!overlays[id]?.isActive, [overlays]);

  return (
    <OverlaysContext.Provider
      value={{
        hideOverlay,
        showOverlay,
        checkIsActive,
      }}>
      {children}
    </OverlaysContext.Provider>
  );
};

export const useOverlays = () => useContext(OverlaysContext);

export default OverlaysProvider;
